export default function getSidetripsForPlaceFactory(ajax) {
  return async function getSidetripsForPlace({ placeId }) {
    const ids = placeId.split(',');
    return await ajax({
      resource: `places/localities?start_place=${ids[0]}&end_place=${ids[1]}`,
    });
  };
}



// WEBPACK FOOTER //
// ./src/services/getPlacesForPlace.js